export enum PillSize {
  SM = 'sm',
  MD = 'md',
}

export enum PillType {
  NEUTRAL = 'neutral',
  BRAND = 'brand',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  PREMIUM = 'premium',
  PREMIUM_PLUS = 'premiumPlus',
  AI = 'ai',
}

export interface PillProps {
  label: string;
  type?: PillType;
  size?: PillSize;
  isFilled?: boolean;
  icon?: string;
  className?: string;
  'data-testid'?: string;
}
